// Query-string assembly for iframe-embedded external services (forms, prayer).
// Extracted from src/pages/forms/_formName.vue so both embed pages share one
// hardened implementation: it skips null/undefined values, never overwrites a
// key the base URL already carries, and appends before any hash fragment.

const normalizeQueryValue = value => {
  if (value === null || value === undefined) return null;
  return String(value);
};

const getQueryKeys = url => {
  const queryStartIndex = url.indexOf('?');
  if (queryStartIndex === -1) return new Set();

  const hashStartIndex = url.indexOf('#', queryStartIndex);
  const queryString = url.slice(
    queryStartIndex + 1,
    hashStartIndex === -1 ? undefined : hashStartIndex,
  );
  const keys = new Set();
  new URLSearchParams(queryString).forEach((_, key) => keys.add(key));
  return keys;
};

export const appendQueryParams = (baseUrl, ...paramSources) => {
  const existingKeys = getQueryKeys(baseUrl);
  const extraParams = [];

  for (const source of paramSources) {
    for (const [key, value] of Object.entries(source || {})) {
      if (existingKeys.has(key)) continue;

      const normalizedValue = normalizeQueryValue(value);
      if (normalizedValue === null) continue;

      existingKeys.add(key);
      extraParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(normalizedValue)}`);
    }
  }

  if (extraParams.length === 0) return baseUrl;

  const hashStartIndex = baseUrl.indexOf('#');
  const urlWithoutHash = hashStartIndex === -1 ? baseUrl : baseUrl.slice(0, hashStartIndex);
  const hash = hashStartIndex === -1 ? '' : baseUrl.slice(hashStartIndex);
  const separator = urlWithoutHash.includes('?') ? '&' : '?';

  return `${urlWithoutHash}${separator}${extraParams.join('&')}${hash}`;
};
